import cx from 'classnames'
import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {Body2, Caption, Headline2} from '@adv-mt/ui/typography'

import {BASE_CLASS} from '../config.js'

const FareOption = ({children, description, fee, id, isSelected, name, onSelect, value}) => {
  const {i18n} = useSuiContext()

  return (
    <div className={cx(`${BASE_CLASS}-fareOption`, isSelected && `${BASE_CLASS}-fareOption--selected`)}>
      <input
        checked={isSelected}
        className={`${BASE_CLASS}-fareOptionInput`}
        id={id}
        name={name}
        onChange={onSelect}
        type="radio"
        value={value}
      />
      <label className={`${BASE_CLASS}-fareOptionLabel`} htmlFor={id}>
        <span className={`${BASE_CLASS}-fareOptionAmount`}>
          <Headline2 as="span">{i18n.c(fee)}</Headline2>
          <Body2 highlight>/{i18n.t('COMMON.PLURALS.MONTH', 1).toLowerCase()}*</Body2>
        </span>
        <Caption>{description}</Caption>
      </label>
      {children}
    </div>
  )
}

FareOption.displayName = 'FareOption'

FareOption.propTypes = {
  children: PropTypes.node,
  description: PropTypes.string.isRequired,
  fee: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
}

export default FareOption
